import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Auth0Provider } from '@auth0/auth0-react'
import type { AppState } from '@auth0/auth0-react'
import './index.css'
import App from './App'
import {
  getAuth0AuthorizationParams,
  getAuth0ClientId,
  getAuth0Domain,
} from './lib/auth0Config'

const root = document.getElementById('root')

if (!root) {
  throw new Error('No se encontró el elemento root en el DOM')
}

function onRedirectCallback(appState?: AppState) {
  // After Auth0 redirect, always restore the URL to root so the browser bar
  // never shows /callback?code=...&state=... to the user.
  // Auth0CallbackHandler will take over and navigate to / via React Router.
  const returnTo = appState?.returnTo ?? '/'
  window.history.replaceState({}, document.title, returnTo)
}

createRoot(root).render(
  <StrictMode>
    <Auth0Provider
      domain={getAuth0Domain()}
      clientId={getAuth0ClientId()}
      authorizationParams={getAuth0AuthorizationParams()}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
      useRefreshTokens
      useRefreshTokensFallback
    >
      <App />
    </Auth0Provider>
  </StrictMode>,
)
